module.exports = __webpack_public_path__ + "img/ntv-64x64.bd5ab30a.png";